export const IS_MAC =
  navigator.platform?.startsWith('Mac') || navigator.userAgent.includes('Mac');
